import Vue from 'vue'
Vue.filter('timeFilter',function(time){
    let oDate = new Date(time*1000)
    return `${oDate.getFullYear()}.${oDate.getMonth()+1}.${oDate.getDate()} `
})